import { observer } from 'mobx-react-lite';

import { Box, BoxProps, Grid, styled } from '@mui/material';
import GridContainer from '../components/container/GridContainer';
import { useStore } from '../store/context';
import BookingsTable from '../components/tables/BookingsTable';
import Documents from '../views/documents/Documents';
import CardContainer from '../components/cards/CardContainer';
import useMedia from '../hooks/useMedia';

const Container = styled(Box)<BoxProps>(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const BookingsPage = observer((): JSX.Element => {
  // welcomeApi
  const { welcomeStore } = useStore();
  const { currentEstate } = welcomeStore;
  const isMobile = useMedia('md');

  if (!currentEstate?.customerId) {
    return <div>Keine Kundennummer vorhanden</div>;
  }

  const documentGroups = ['Belege zur Jahresabrechnung', 'Jahresabrechnung'];

  const title = 'Buchungen';

  return (
    <GridContainer>
      <Grid container>
        <Documents documentGroups={documentGroups} initialyShowDocs={false} />
        <Grid item xs={12} marginTop={2}>
          <Container>
            <CardContainer
              title={title}
              customStyle={{
                sx: {
                  margin: isMobile ? 0 : 5,
                },
              }}
              iconOn
              iconName={title}
            >
              <BookingsTable customerId={currentEstate?.customerId} />
            </CardContainer>
          </Container>
        </Grid>
      </Grid>
    </GridContainer>
  );
});

export default BookingsPage;
